import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllDriversQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  nameIncludes?: Types.InputMaybe<Types.Scalars['String']>;
  customer?: Types.InputMaybe<Types.Scalars['Float']>;
  text?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllDriversQuery = { __typename?: 'Query', allDrivers?: { __typename?: 'DriverNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'DriverNodeEdge', cursor: string, node?: { __typename?: 'DriverNode', id: string, phone?: string | null, name: string, email?: string | null } | null } | null> } | null };


export const AllDriversDocument = gql`
    query AllDrivers($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $nameIncludes: String, $customer: Float, $text: String) {
  allDrivers(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    nameIncludes: $nameIncludes
    customer: $customer
    text: $text
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        phone
        name
        email
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllDriversQuery__
 *
 * To run a query within a React component, call `useAllDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDriversQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameIncludes: // value for 'nameIncludes'
 *      customer: // value for 'customer'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAllDriversQuery(baseOptions?: Apollo.QueryHookOptions<AllDriversQuery, AllDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDriversQuery, AllDriversQueryVariables>(AllDriversDocument, options);
      }
export function useAllDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDriversQuery, AllDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDriversQuery, AllDriversQueryVariables>(AllDriversDocument, options);
        }
export type AllDriversQueryHookResult = ReturnType<typeof useAllDriversQuery>;
export type AllDriversLazyQueryHookResult = ReturnType<typeof useAllDriversLazyQuery>;
export type AllDriversQueryResult = Apollo.QueryResult<AllDriversQuery, AllDriversQueryVariables>;